import { CoordinatorService } from './coordinator.service';
import { ScriptWidget } from './script-widget';

export class ScriptInterface {
    #coords: CoordinatorService;
    #type: string;

    private _widgetMap = new Map<string, ScriptWidget>();

    constructor(coords: CoordinatorService, type: string) {
        this.#coords = coords;
        this.#type = type;

        switch (this.#type) {
            case 'search':
                this._initSearch();
                break;
            default:
                console.log('Unknown Interface Type', type);
        }
    }

    private _initSearch() {
        ['field-board', 'selection-board', 'filter-board'].forEach((tag) => {
            const field = this.#coords.script$.widgetGet(tag);
            field && this._widgetMap.set(field.id, field);
        });

        // console.log('QQQ', this._widgetMap);
    }

    widget(tag: string) {
        return this._widgetMap.get(tag);
    }

    reset() {
        switch (this.#type) {
            case 'search':
                this.#coords.search$.clearAll();
                break;
            default:
                console.log('Unknown Interface Type', this.#type);
        }
    }
}
